import * as React from 'react'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ContentBack } from './ContentBack/ContentBack'
import { ContentFront } from './ContentFront/ContentFront'
import {
  flipCard,
  selectClosedWonQueueSubmissionsSettings,
} from '@user/store/dashboard/widgets/closedWonQueueSubmissions/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { WidgetWrapper } from '../../Widget/WidgetWrapper'

export const ClosedWonQueueSubmissions: FC = () => {
  const dispatch = useAppDispatch()
  const { showFront } = useSelector(selectClosedWonQueueSubmissionsSettings)

  const handleFlipCard = useCallback(() => {
    dispatch(flipCard())
  }, [dispatch])

  return (
    <WidgetWrapper
      testIdPrefix="closed-won-queue-submissions-widget"
      contentFront={<ContentFront />}
      contentBack={<ContentBack />}
      title="Closed Won Queue Submissions"
      settingsAction={handleFlipCard}
      showFront={showFront}
    />
  )
}

ClosedWonQueueSubmissions.displayName = 'ClosedWonQueueSubmissions'
